import { createSelector } from 'reselect';
import { getWorkspace } from './workspaceSelectors';

export const getUser = (state) => state.currentUser.user;
export const getUpdateMarkers = (state) => state.currentUser.markers;

export const getUserRole = createSelector(
    getUser,
    getWorkspace,
    (user, workspace) => (
        user.workspaces.find((item) => item.workspace === workspace._id)?.role
    )
);
